import { createContext, useContext,useState} from "react";
import { getInterviewStorageSuffix } from "../utils/interviewSession.js";

const PermissionContext = createContext();

export const usePermission = () => useContext(PermissionContext);

export const PermissionProvider = ({ children }) => {
    const storageKey = (key) => `${key}_${getInterviewStorageSuffix()}`;

    const [termsAccept, setTermsAccept] = useState(
        localStorage.getItem(storageKey("termsAccepted")) === "true"
    );

    const [audioVideoAccepted, setAudioVideoAccepted] = useState(
        localStorage.getItem(storageKey("hasPermissions")) === "true"
    );

    const [isExamSubmitted, setIsExamSubmitted] = useState(
        localStorage.getItem(storageKey("interviewSubmitted")) === "true"
    );

    const acceptTerms = () => {
        setTermsAccept(true);
        localStorage.setItem(storageKey("termsAccepted"), "true");
    };

    const acceptAudioVideo = () => {
        setAudioVideoAccepted(true);
        localStorage.setItem(storageKey("hasPermissions"), "true");
    };

    const submitExam = () => {
        setIsExamSubmitted(true);
        localStorage.setItem(storageKey("interviewSubmitted"), "true");
    };

    return (
        <PermissionContext.Provider value={{ termsAccept, audioVideoAccepted, isExamSubmitted, acceptAudioVideo, acceptTerms, submitExam }}>
            {children}
        </PermissionContext.Provider>
    );
};
